import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReceptionRoutingModule } from './reception-routing.module';
import { VisitorComponent } from '../reception/visitor/visitor.component';
import { ReceptionComponent } from '../reception/reception/reception.component';
import { EnquiryTypeComponent } from '../reception/enquiry-type/enquiry-type.component';
import { AppointmentComponent } from '../reception/appointment/appointment.component';
import { IssuedProspectusComponent } from '../reception/issued-prospectus/issued-prospectus.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule, TimepickerModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgxEditorModule } from 'ngx-editor';



@NgModule({
  declarations: [VisitorComponent, ReceptionComponent, EnquiryTypeComponent, AppointmentComponent, IssuedProspectusComponent],
  imports: [
    CommonModule,
    AdminModule,
    ReceptionRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgxEditorModule,
  ]
})
export class ReceptionModule { }
